import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { TWAppDownloadPage } from './TWAppDownloadPage'

export const TWAppDownloadPageRegistration = createRegisterableComponent(
    'tw-app-download-page',
    () => <TWAppDownloadPage />,
)
